import React from 'react'
import ImgUtil from '../../../utils/img.utils'
import WrapperImage from '../wrapperImage'
import WrapperVideo from '../wrapperVideo'
import { ModuleNames } from '../../../constants/componentNames.constants'

const VerticalMedia = ({ media }: any) => {
  let mediaComponent = null
  const imgUrl = media?.image?.file?.url
  const assetAltText = media?.asset?.altText
  const assetImgUrl = media?.asset?.image?.file?.url
  const videoSrc = media?.animationFile?.file?.url
  const videoType = videoSrc?.substring(videoSrc.length - 3);

  switch (media?.__typename) {
    case ModuleNames.WRAPPER_ASSET: 
      mediaComponent = (
        <div className="VerticalTabs__Media" data-cy="VerticalMedia">
          <WrapperImage 
            src={ImgUtil.getResizedImageUrl(imgUrl, '')}
            alt={media?.altText}
            width={500}
            height={500}
          />
        </div>
      )
      break
    case ModuleNames.WRAPPER_VIDEO:
      mediaComponent = (
        <div className="VerticalTabs__Media" data-cy="VerticalMedia">
          <WrapperVideo 
            width={500}
            height={300}
            videoSrc={videoSrc}
            videoType={videoType}
            youtubeID={media?.youtubeId}
          />
        </div>
      )
      break
    case ModuleNames.MEDIA_ASSET:
      mediaComponent = (
        <div className="VerticalTabs__Media" data-cy="VerticalMedia">
          <WrapperImage 
            src={ImgUtil.getResizedImageUrl(assetImgUrl, '')}
            alt={assetAltText}
            width={400}
            height={400}
          />
        </div>
      )
      break
  }

  return mediaComponent
}

export default VerticalMedia